import React from 'react'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import GalleryInner from '../Components/GalleryInner/GalleryInner'

function Gallery() {
  return (
    <div>
        <Header/>
        <GalleryInner/>
        <Footer/>
    </div>
  )
}

export default Gallery